import {useCompletedWalletLoads} from '~/api/deimos/wallet'
import {useUser} from '~/shell/user'

export const useHasAWalletLoad = () => {
    const user = useUser()
    const {data: loads, isLoading} = useCompletedWalletLoads(user?.companyId)
    // filtering based on type definition in ~/api/deimos/wallet
    return {
        isLoading,
        hasAWalletLoad: loads?.some((load) => load.type === 'LOAD'),
    }
}
